import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

function AdminCreateUser() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!window.confirm(`Are you sure you want to create an account for ${email}?`)) {
            return;
        }
        setLoading(true);

        try {
            const functions = getFunctions();
            const createUserByAdmin = httpsCallable(functions, 'createUserByAdmin');
            const result = await createUserByAdmin({ email, password });

            alert(result.data.result);
            // Clear form on success
            setEmail('');
            setPassword('');
        } catch (error) {
            console.error("Error creating user:", error);
            alert(`Failed to create user: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Create a New User Account</h2>
            <p>Use this form to create a new, fully-enabled user account.</p>
            <form onSubmit={handleSubmit} style={{ maxWidth: '500px' }}>
                <fieldset>
                    <legend>New User Details</legend>
                    <label>User's Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="new.user@example.com"
                        required
                    />
                    <br /><br />
                    <label>Temporary Password:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Min. 6 characters"
                        required
                    />
                    <br /><br />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Creating Account...' : 'Create Account'}
                    </button>
                </fieldset>
            </form>
        </div>
    );
}

export default AdminCreateUser;